import { useLingui } from "@lingui/react/macro";
import { formatDate } from "@offstreetparking/design-system/formatters";
import { useLocale } from "@offstreetparking/design-system/providers";
import { Heading, Link, Text } from "@offstreetparking/design-system/typography";
import { routes } from "../../../../routes";
import type { Permit } from "../types";
export const ParkerTermsSection = ({
	parkerTerms,
	acceptedDate,
}: {
	parkerTerms: Permit["parkerTerms"];
	acceptedDate: Permit["createdDate"];
}) => {
	const { t } = useLingui();
	const { locale } = useLocale();
	if (!parkerTerms || parkerTerms.length === 0) {
		return null;
	}
	return (
		<div className="mt-4 space-y-4 border-neutral-faded border-t pt-6">
			<div>
				<Heading As="h2" kind="h3" className="mb-1">
					{t`Accepted Terms`}
				</Heading>
				<Text size="sm" intent="muted">
					{t`Accepted ${formatDate({ date: acceptedDate, formatType: "Abbreviated_Date", language: locale })}`}
				</Text>
			</div>
			<div className="space-y-2">
				{parkerTerms.map((terms, index) => (
					<div key={terms.publicIdentifier}>
						<Text As="span">{terms.title || t`Terms #${String(index + 1)}`}</Text> [
						<Link
							variant="action"
							href={routes.terms({
								publicIdentifier: terms.publicIdentifier,
							})}
							className="p-0"
							isExternal
						>
							{t`View`}
						</Link>
						]
					</div>
				))}
			</div>
		</div>
	);
};
